module.exports = __webpack_public_path__ + "static/media/icon_basketball.ee83cc8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_basketball.png
// module id = 137
// module chunks = 0